import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useSiteAssets } from "context/SiteAssetsContext";
import { SITE_ASSET_KEYS } from "utils/siteAssets";

function HeroSection() {
  const { getAssetUrl } = useSiteAssets();
  const logoUrl = getAssetUrl(SITE_ASSET_KEYS.LOGO_APLIKASI);
  const bgUrl = getAssetUrl(SITE_ASSET_KEYS.BG_HERO_LANDING);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <MDBox
      id="beranda"
      component="section"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        position: "relative",
        backgroundImage: `linear-gradient(135deg, rgba(13,71,161,0.88) 0%, rgba(27,94,32,0.82) 100%), url(${bgUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        pt: 12,
        pb: 8,
      }}
    >
      <Container>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={7}>
            <MDBox
              display="inline-flex"
              alignItems="center"
              gap={1}
              px={2}
              py={0.75}
              mb={2}
              borderRadius="lg"
              sx={{ backgroundColor: "rgba(255,255,255,0.15)", backdropFilter: "blur(4px)" }}
            >
              <MDBox component="img" src={logoUrl} alt="Logo" width="2rem" />
              <MDTypography variant="caption" color="white" fontWeight="medium">
                Pemerintah Kabupaten Rote Ndao
              </MDTypography>
            </MDBox>

            <MDTypography variant="h2" color="white" fontWeight="bold" mb={2} sx={{ fontSize: { xs: "1.75rem", md: "2.75rem" } }}>
              Dinas Penanaman Modal dan Pelayanan Terpadu Satu Pintu
            </MDTypography>

            <MDTypography variant="h5" color="white" fontWeight="regular" opacity={0.95} mb={1}>
              Kabupaten Rote Ndao
            </MDTypography>

            <MDTypography variant="body1" color="white" opacity={0.9} mb={4} maxWidth="36rem">
              TIALAI — platform digital pelayanan perizinan dan nonperizinan. Ajukan permohonan
              secara online, pantau progres layanan, dan nikmati pelayanan publik yang transparan.
            </MDTypography>

            <MDBox display="flex" flexWrap="wrap" gap={2}>
              <MDButton variant="gradient" color="success" size="large" onClick={() => scrollTo("layanan")}>
                Lihat Layanan
              </MDButton>
              <MDButton
                variant="outlined"
                color="white"
                size="large"
                component={Link}
                to="/authentication/sign-up/cover"
                sx={{ borderColor: "white", color: "white !important" }}
              >
                Daftar Pemohon
              </MDButton>
              <MDButton
                variant="text"
                color="white"
                size="large"
                onClick={() => scrollTo("pengaduan")}
                sx={{ color: "white !important" }}
              >
                Kirim Pengaduan
              </MDButton>
            </MDBox>
          </Grid>

          <Grid item xs={12} md={5}>
            <MDBox
              borderRadius="xl"
              p={3}
              sx={{
                backgroundColor: "rgba(255,255,255,0.12)",
                backdropFilter: "blur(12px)",
                border: "1px solid rgba(255,255,255,0.2)",
              }}
            >
              <MDTypography variant="h6" color="white" fontWeight="bold" mb={2}>
                Visi Pelayanan Kami
              </MDTypography>
              {[
                "Pelayanan perizinan cepat, mudah, dan akuntabel",
                "15 jenis layanan perizinan & nonperizinan",
                "Pengajuan dan pelacakan status secara online",
                "Verifikasi dokumen izin melalui kode QR",
              ].map((text) => (
                <MDBox key={text} display="flex" alignItems="flex-start" gap={1.5} mb={1.5}>
                  <MDBox
                    width="1.5rem"
                    height="1.5rem"
                    borderRadius="50%"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    bgColor="success"
                    flexShrink={0}
                    mt={0.25}
                  >
                    <MDTypography variant="caption" color="white" fontWeight="bold">
                      ✓
                    </MDTypography>
                  </MDBox>
                  <MDTypography variant="body2" color="white" opacity={0.95}>
                    {text}
                  </MDTypography>
                </MDBox>
              ))}
            </MDBox>
          </Grid>
        </Grid>
      </Container>
    </MDBox>
  );
}

export default HeroSection;
